module.exports = __webpack_public_path__ + "static/img/church_01.edf9781.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/church_01.png
// module id = qAUF
// module chunks = 0